<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="bagsis"
    class="d-none d-md-flex"
  >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <div class="cliente-nome" v-b-modal.modal-trocar-cliente>
      {{ cliente_nome }}
    </div>
    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
          <b-form-input
            size="sm"
            class="mr-sm-2"
            placeholder="Pesquisar"
          ></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit"
            >Busca rápida</b-button
          >
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse>
    <User />

    <b-modal
      id="modal-trocar-cliente"
      ref="modal-trocar-cliente"
      title="Trocar Cliente"
      scrollable
      @ok="trocarCliente"
      @show="getClientes"
    >
      <div class="text-center my-2" v-if="loading_clientes">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>carregando ...</strong>
      </div>
      <div v-else>
        <b-form-group label="Selecione um Cliente ">
          <b-form-radio-group
            v-model="cliente_id"
            :options="clientes"
            value-field="id"
            text-field="nome"
            name="select-clientes"
            stacked
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </b-modal>
  </b-navbar>
</template>
<script>
import User from "@/components/SidebarPlugin/User.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { User },
  data: () => ({
    loading_clientes: false,
    clientes: [],
    cliente_id: null,
  }),
  computed: {
    ...mapGetters("auth", ["getCliente"]),
    cliente_nome() {
      return this.getCliente.pessoa_juridica
        ? this.getCliente.pessoa_juridica.nome
        : "";
    },
  },
  methods: {
    ...mapActions("users", ["ActionGetCliente", "ActionTrocarCliente"]),
    async getClientes() {
      this.loading_clientes = true;
      try {
        this.clientes = await this.ActionGetCliente();
      } catch (err) {}

      this.loading_clientes = false;
    },
    async trocarCliente() {
      if (this.cliente_id) {
        this.loading_clientes = true;
        try {
          await this.ActionTrocarCliente(this.cliente_id);
          location.reload();
        } catch (err) {}
        this.loading_clientes = false;
      }
    },
  },
};
</script>

<style lang="scss">
.cliente-nome {
  color: #ffffff;
  font-weight: bold;
  margin-top: -1rem;
}
</style>
